import { render, staticRenderFns } from "./SBFManage.vue?vue&type=template&id=ba0bf742&scoped=true&"
import script from "./SBFManage.vue?vue&type=script&lang=js&"
export * from "./SBFManage.vue?vue&type=script&lang=js&"
import style0 from "./SBFManage.vue?vue&type=style&index=0&id=ba0bf742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0bf742",
  null
  
)

export default component.exports